export * from './cs-page-title.component';



// WEBPACK FOOTER //
// ./src/app/components/cs-page-title/index.ts